<script lang="ts" setup>
  // Add your code here ...
</script>

<template>
  <div class="text-start">
    <p class="mt-5">
      Para executar o plugin de
      <strong>instalação de Certificados Digitais A1</strong>, é necessário
      identificar o sistema operacional do seu computador. Siga os passos abaixo
      para executar o plugin em <strong>Windows</strong>,
      <strong>MacOS</strong> e <strong>Linux</strong>.
    </p>

    <h3 class="fw-700 mt-4 install--os--title">Para Windows</h3>
    <div class="info-container bg--grayscale-default-100 px-1 py-3 mt-4">
      <ol class="m-0">
        <li>Baixe o plugin, “BirdID-Sign-Plugin.exe”, em seu computador.</li>
        <li>
          Na pasta de downloads,
          <strong>identifique o arquivo e clique duas vezes para abri-lo</strong
          >. Ou, com o botão direito do mouse, clique no arquivo e, em seguida,
          clique em ”<strong>Abrir</strong>”.
        </li>
        <li>
          <strong>Pronto!</strong> Prossiga com a instalação do seu Certificado
          Digital A1.
        </li>
      </ol>
    </div>

    <h3 class="fw-700 mt-5 install--os--title">Para MacOS</h3>
    <div class="info-container bg--grayscale-default-100 px-1 py-3 mt-4">
      <ol class="m-0">
        <li>Baixe o plugin, “BirdID-Sign-Plugin.dmg”, em seu computador.</li>
        <li>
          Na pasta de downloads,
          <strong>identifique o arquivo e clique duas vezes para abri-lo</strong
          >. Ou, com o botão direito do mouse, clique no arquivo e, em seguida,
          clique em ”<strong>Abrir</strong>”.
        </li>
        <li>
          <strong>Pronto!</strong> Prossiga com a instalação do seu Certificado
          Digital A1.
        </li>
      </ol>
    </div>

    <h3 class="fw-700 mt-5 install--os--title">Para Linux</h3>
    <div class="info-container bg--grayscale-default-100 px-1 py-3 mt-4">
      <ol class="m-0 p-end-4">
        <li>Baixe o plugin, “BirdID-Sign-Plugin”, em seu computador.</li>
        <li>
          Na pasta de downloads,
          <strong>identifique o arquivo e clique duas vezes para abri-lo</strong
          >. Ou, com o botão direito do mouse, clique no arquivo e, em seguida,
          clique em ”<strong>Abrir</strong>”.
        </li>
        <li>
          <strong>Pronto!</strong> Prossiga com a instalação do seu Certificado
          Digital A1.
        </li>
      </ol>
    </div>
  </div>
</template>

<style scoped>
  .info-container {
    font-size: 0.875rem !important;
  }
  .info-container li {
    margin: 2rem 0.25rem;
  }

  .info-container li:first-child {
    margin: 0 0.25rem 2rem 0.25rem;
  }
  .info-container li:last-child {
    margin: 2rem 0.25rem 0 0.25rem;
  }
  .install--os--title {
    font-size: 1rem !important;
  }
</style>
